import { useDispatch, useSelector } from 'react-redux';

import { setHeadersAction, getHeaders, clearHeadersAction } from 'features/headers/redux/slice';

import { UseHeadersState, HeadersApiResponse } from './types';

const useMenu = (): UseHeadersState => {
  const headers = useSelector(getHeaders);
  const dispatch = useDispatch();

  const setHeaders = (headers: HeadersApiResponse) => {
    dispatch(setHeadersAction(headers));
  };

  const clearHeaders = () => {
    dispatch(clearHeadersAction());
  };

  return {
    headers,
    setHeaders,
    clearHeaders,
  };
};

export default useMenu;
